import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import DocumentAnnotator from "@/components/DocumentAnnotator";

function DocumentAnnotatePage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const url = params.get("url");
  const name = params.get("name") || url?.split("?")[0].split("/").pop() || "";
  const file = useMemo(() => (url ? { name, url } : null), [name, url]);

  useEffect(() => {
    if (name) document.title = name;
  }, [name]);

  const handleClose = () => {
    window.close();
    if (!window.closed) window.history.back();
  };

  if (!file) {
    return (
      <div className="flex min-h-screen items-center justify-center p-8 text-gray-500">
        {t("docAnnotate.missingFile")}
      </div>
    );
  }

  return <DocumentAnnotator file={file} onClose={handleClose} />;
}

export default DocumentAnnotatePage;
